export default __webpack_public_path__ + "static/media/18_1.e717b31f.jpg";